import React from 'react'

export default function Footer() {
    return (
        <div>
            <nav className="footer" >
                <div className="navigation">
                    <ul class="menu">
                        <li><a href="https://claytondegallerie.com" target="_blank">ClaytonDegallerie.com &copy;</a></li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}
